var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-apex-charts',{attrs:{"type":"area","height":"168","options":_vm.OverviewCampaignData.overviewChart.chartOptions,"series":_vm.OverviewCampaignData.overviewChart.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }